import { useMemo } from "react";
import { AuthState, useAuthStore } from "../store/authStore";

export const useAuth = () => {
  const user = useAuthStore((state: AuthState) => state.user);
  const accessToken = useAuthStore((state: AuthState) => state.accessToken);
  const refreshToken = useAuthStore((state: AuthState) => state.refreshToken);
  const setSession = useAuthStore((state: AuthState) => state.setSession);
  const clearSession = useAuthStore((state: AuthState) => state.clearSession);

  return useMemo(
    () => ({
      user,
      accessToken,
      refreshToken,
      isAuthenticated: Boolean(user && accessToken),
      setSession,
      clearSession,
    }),
    [user, accessToken, refreshToken, setSession, clearSession]
  );
};
